module.exports = __webpack_public_path__ + "assets/img/vislogo.8a6cafd4.png";